import { push } from 'redux-first-history';
import { SelfServiceEnrollImprivataId } from '@imprivata/self-service-client';

import * as types from '../constants/cidraActions';
import {
  IID_ENROLL, SMS_ENROLL_PHONE, SMS_ENROLL_VERIFY, SELF_SERVICE_ENROLL, SECOND_FACTOR
} from '../constants/contexts';
import {
  doSmsEnrollVerifyStart, startLoading, setServerState,
  doLogout, doSecondFactorFailure, doStartEnrollSms, doStartEnrollImprivataId, doSelfServiceError, doSetAuthenticationToken
} from './shared';
import { decideNextStep } from './decideNextStep';
import getErrorMessage from '../constants/getMessage';
import { EnrollmentProtocols } from '../constants/clientProtocols';


export function doEnrollSms(input) {
  return function(dispatch, getState) {
    const { EnrollInitEnrollSms, EnrollResponseEnrollmentFailed, } = EnrollmentProtocols;
    const { authClient, oneSignSessionId, } = getState().login;

    dispatch(doStartEnrollSms() );
    dispatch(startLoading() );
    const enrollSms = new EnrollInitEnrollSms(oneSignSessionId, input);
    return authClient.sendRequest(enrollSms).then(response => {
      const serverState = response.message;
      dispatch(setServerState(serverState) );
      if (serverState.responseType === EnrollResponseEnrollmentFailed) {
        dispatch(doLogout() );
        dispatch(doSecondFactorFailure(serverState.errorCode) );
      }
      else if (serverState.errorCode) {
        dispatch(doSMSEnrollError(serverState.errorCode, SMS_ENROLL_PHONE) );
      }
      else {
        dispatch(doSmsEnrollVerifyStart(input) );
        dispatch(decideNextStep(serverState, false) );
      }
    });
  };
}

export function doEnrollImprivataId(serial, tokenCode) {
  return function(dispatch, getState) {
    const { EnrollVerifyImprivataId, EnrollResponseEnrollmentFailed, } = EnrollmentProtocols;
    const {
      session, authClient, oneSignSessionId, isDeviceManagementWorkflow,
    } = getState().login;

    dispatch(doStartEnrollImprivataId() );
    dispatch(startLoading() );
    if(!isDeviceManagementWorkflow) {
      const encryptedToken = session.encryptSecret(tokenCode);
      const enrollVerifyImprivataIdOtp = new EnrollVerifyImprivataId(oneSignSessionId, encryptedToken.value, serial);
      return authClient.sendRequest(enrollVerifyImprivataIdOtp).then(response => {
        const serverState = response.message;
        dispatch(setServerState(serverState) );
        if (serverState.responseType === EnrollResponseEnrollmentFailed) {
          dispatch(doLogout() );
          dispatch(doSecondFactorFailure(serverState.errorCode) );
        }
        else if (serverState.errorCode) {
          dispatch(doImprivataIdEnrollError(serverState.errorCode, IID_ENROLL, serial) );
        }
        else {
          dispatch(doImprivataIdEnrolledStart() );
          dispatch(decideNextStep(serverState, false, true) );
        }
      });
    }
    else {
      // tests ! Should saparate this to another function for testing
      // Enroll via Self-Service Device Management
      const {
        selfServiceEnvironment,
        selfServiceVersion,
        authenticationToken,
        oneSignTenantId,
        oneSignUserId,
        interplexAddress,
        cloudAuthTenantId,
      } = getState().login;

      return SelfServiceEnrollImprivataId(
        selfServiceEnvironment,
        selfServiceVersion,
        authenticationToken,
        oneSignTenantId,
        oneSignUserId,
        interplexAddress,
        serial,
        tokenCode,
        cloudAuthTenantId)
        .then(result => {
        // console.log("EnrollImprivataId result:", result);
          // Check result for success/error info
          if(!result.ok) {
            if(!result.fail) {
              // soft error, allow user to retry enrollment
              dispatch(doSelfServiceError(SELF_SERVICE_ENROLL) );
              dispatch(doSetAuthenticationToken(result.deviceManagementToken) );
            }
            else {
              // console.log("EnrollImprivataId failed");
              // hard error, log user out
              dispatch(doLogout() );
              dispatch(doSelfServiceError(SECOND_FACTOR) );
            }
          }
          else {
            dispatch(doSetAuthenticationToken(result.deviceManagementToken) );
            if(result.deviceList != null) {
              dispatch(doUpdateDeviceList(result.deviceList) );
            }
            dispatch(doImprivataIdEnrolledStart() );
            dispatch(push('/enrollimprivataid') );
          }
        },
        () => {
          dispatch(doSelfServiceError(SELF_SERVICE_ENROLL) );
        });
    }
  };
}

export function doEnrollVerifySms(input) {
  return function(dispatch, getState) {
    const { EnrollVerifyOutOfBand, EnrollResponseEnrollmentFailed, } = EnrollmentProtocols;
    const {
      session, authClient, oneSignSessionId,
    } = getState().login;

    dispatch(doStartEnrollVerifySms() );
    dispatch(startLoading() );
    const encryptedToken = session.encryptSecret(input);
    const enrollVerifyOob = new EnrollVerifyOutOfBand(oneSignSessionId, encryptedToken.value);
    return authClient.sendRequest(enrollVerifyOob).then(response => {
      const serverState = response.message;
      dispatch(setServerState(serverState) );
      if (serverState.type === EnrollResponseEnrollmentFailed) {
        dispatch(doLogout() );
        dispatch(doSecondFactorFailure(serverState.errorCode) );
      }
      else if (serverState.errorCode) {
        dispatch(doSMSEnrollError(serverState.errorCode, SMS_ENROLL_VERIFY) );
      }
      else {
        dispatch(doSmsEnrolledStart() );
        dispatch(decideNextStep(serverState, false, true) );
      }
    });
  };
}

export function doSkipEnrollment() {
  return function(dispatch, getState) {
    const { EnrollSkipEnrollment, EnrollResponseEnrollmentFailed, } = EnrollmentProtocols;
    const { authClient, oneSignSessionId, } = getState().login;

    dispatch(startLoading() );
    const skipEnrollment = new EnrollSkipEnrollment(oneSignSessionId);
    return authClient.sendRequest(skipEnrollment)
      .then(response => {
        const serverState = response.message;
        dispatch(setServerState(serverState) );
        if (serverState.responseType === EnrollResponseEnrollmentFailed) {
          dispatch(doLogout() );
          dispatch(doSecondFactorFailure(serverState.errorCode) );
        }
        else if (serverState.errorCode) {
          dispatch(doLogout() );
          dispatch(doSecondFactorFailure(serverState.errorCode) );
        }
        else {
          // Should be complete at this point
          dispatch(decideNextStep(serverState, true) );
        }
      }
      );
  };
}

export function doSmsEnrolled() {
  return function(dispatch, getState) {
    const { serverState, } = getState().login;
    return dispatch(decideNextStep(serverState, true) );
  };
}

export function doSubmitAfterSSDM() {
  return function(dispatch, getState) {
    const { serverState, } = getState().login;
    return dispatch(decideNextStep(serverState, true) );
  };
}

export function doImprivataIdEnrolled() {
  return function(dispatch, getState) {
    const { serverState, } = getState().login;
    dispatch(doSetPrimaryFactorEnrolled(true) );
    return dispatch(decideNextStep(serverState, true) );
  };
}

export function doSMSEnrollError(errorCode, context) {
  const errorMessage = getErrorMessage(errorCode, context);
  return {
    errorCode,
    errorMessage,
    type: types.ENROLL_RETRY,
  };
}

export function doImprivataIdEnrollError(errorCode, context, serialNumber) {
  const errorMessage = getErrorMessage(errorCode, context, serialNumber);
  return {
    errorCode,
    errorMessage,
    type: types.ENROLL_RETRY,
  };
}

export function doImprivataIdEnrolledStart() {
  return { type: types.IMPRIVATA_ID_ENROLL_SUCCESS, };
}

export function doUpdateDeviceList(deviceList) {
  return {
    type: types.UPDATE_DEVICE_LIST,
    deviceList,
  };
}

export function doStartEnrollVerifySms() {
  return { type: types.START_ENROLL_VERIFY_SMS, };
}

export function doSmsEnrolledStart() {
  return { type: types.SMS_ENROLL_VERIFY_SUCCESS, };
}

export function doSetPrimaryFactorEnrolled(isEnrolled) {
  return {
    type: types.SET_PRIMARY_FACTOR_ENROLLED,
    isEnrolled,
  };
}
